import React from 'react'
import PropTypes from 'prop-types'
import className from '../../utils/className'

import styles from './FlatButton.scss'

export default function FlatButton(props) {
  const { onClick, children, style, ...rest } = props
  return <button onClick={(e) => { e.preventDefault(); onClick(e) }} className={className(styles.flatButton, style)} {...rest}>{children}</button>
}

FlatButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired
}
